import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withHandlers } from 'recompose';
import { withRouter } from 'react-router';

import { t } from '../../../../../../modules/infra/i18n';
import withNewDesignStyles from '../../../../../common/hoc/withNewDesignStyles';
import withNotifications from '../../../../../common/withNotifications';
import withLoading from '../../../../../common/withLoading';
import EditCustomReport from './EditCustomReport';
import {
  getMetricsDefinitions,
  isMetricsDefinitionsFetched,
} from '../../selectors';
import { getBrandId, getUserUrlPrefix } from '../../../../../auth/selectors';
import { fetchMetricsDefinitions, addCustomReport } from '../../actions';
import {
  getApiReportFromFormValues,
} from '../../utils';
import form from './formConfig';

const NewCustomReportContainer = compose(
  withNewDesignStyles,
  withRouter,
  withNotifications,
  connect(state => ({
    metricsDefinitions: getMetricsDefinitions(state),
    fetched: isMetricsDefinitionsFetched(state),
    brandId: getBrandId(state),
    urlPrefix: getUserUrlPrefix(state),
  }),
  { fetchMetricsDefinitions, addCustomReport }),
  withProps(props => ({
    title: t('reports:custom_report_form.new_title'),
    showLoading: !props.fetched,
    initialValues: {
      type: 'barber',
    },
    backLink: '/reports',
  })),
  withHandlers({
    onSubmit: props => values => (
      props.addCustomReport(getApiReportFromFormValues(values, props.brandId))
    ),
  }),
  form,
  withHandlers({
    setReportMetrics: props => (reportMetrics) => {
      props.change('reportMetrics', reportMetrics);
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.fetchMetricsDefinitions();
    },
  }),
  withLoading,
)(EditCustomReport);

export default NewCustomReportContainer;
